"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StockLocation = void 0;
var StockLocation;
(function (StockLocation) {
    StockLocation["POSTOUT"] = "POSTOUT";
    StockLocation["WAREHOUSE"] = "WAREHOUSE";
    StockLocation["STORE"] = "STORE";
    StockLocation["SUPPLIER"] = "SUPPLIER";
    StockLocation["PREORDER"] = "PREORDER";
    StockLocation["INFOPOINT_FALLBACK"] = "INFOPOINT_FALLBACK";
    StockLocation["IN_STORE"] = "IN_STORE";
    StockLocation["IN_OTHER_STORE"] = "IN_OTHER_STORE";
})(StockLocation || (exports.StockLocation = StockLocation = {}));
//# sourceMappingURL=StockEnums.js.map